import Layout from "./Layout.jsx";

import Registration from "./Registration";

import PackageUnavailable from "./PackageUnavailable";

import SeatingService from "./SeatingService";

import PricingPage from "./PricingPage";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

const PAGES = {
  Registration: Registration,

  PackageUnavailable: PackageUnavailable,

  SeatingService: SeatingService,

  PricingPage: PricingPage,
};

function _getCurrentPage(url) {
  if (url.endsWith("/")) {
    url = url.slice(0, -1);
  }
  let urlLastPart = url.split("/").pop();
  if (urlLastPart.includes("?")) {
    urlLastPart = urlLastPart.split("?")[0];
  }

  const pageName = Object.keys(PAGES).find(
    (page) => page.toLowerCase() === urlLastPart.toLowerCase()
  );
  return pageName || Object.keys(PAGES)[0];
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
  const location = useLocation();
  const currentPage = _getCurrentPage(location.pathname);

  return (
    <Layout currentPageName={currentPage}>
      <Routes>
        <Route path="/PackageUnavailable" element={<PackageUnavailable />} />
        <Route path="/SeatingService" element={<SeatingService />} />
        <Route path="/q/" element={<PricingPage />} />
        <Route
          path="/q/:packageHash"
          element={<PricingPage shortLink={true} />}
        />
        <Route
          path="/pq/:packageHash"
          element={<PricingPage shortLink={false} />}
        />
        <Route
          path="/:packageHash"
          element={<Registration shortLink={true} />}
        />
        <Route
          path="/p/:packageHash"
          element={<Registration shortLink={false} />}
        />
        <Route path="*" element={<PackageUnavailable />} />
      </Routes>
    </Layout>
  );
}

export default function Pages() {
  return (
    <Router>
      <PagesContent />
    </Router>
  );
}
